package com.dignicate.web.ui.components.header

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*

@Composable
fun SettingsButton(onClick: () -> Unit) {
    Button(attrs = {
        onClick { onClick() }
        classes("gear-button")
        id("gear-button")
    }) {
        // icon uses span with gear-icon class for sizing; pointer-events disabled so Button handles clicks
        Span(attrs = { classes("gear-icon") }) { Text("⚙") }
    }
}
